import React from 'react'
import { ConfigurationPanel } from '../../legacy-design-system/configuration-panel'
import { css } from '@emotion/css'
import { TtrTimeFilterTypeForm } from './ttr-time-filter-type-form'
import { ViewerLoader } from '../viewer'
import { hasRole } from '../roles'

export function VulnerabilityTtrManager() {
  return (
    <ViewerLoader>
      {({ viewer, loading }) => {
        return (
          !loading &&
          !!viewer &&
          hasRole(viewer.currentOrganization.role, 'RULES_ADMIN') && (
            <ConfigurationPanel title={'title_vulnerabilityTtrProperties'}>
              <div
                className={css`
                  padding: 10px 11px 13px 10px;
                `}
              >
                <TtrTimeFilterTypeForm
                  organizationUuid={viewer.currentOrganization.id}
                />
              </div>
            </ConfigurationPanel>
          )
        )
      }}
    </ViewerLoader>
  )
}
